import React from 'react'

const RectangleSVG: React.FC = () => {
    return (
        <svg version="1.1" x="0px" y="0px" viewBox="0 0 40 40">
            <rect
                fill={'none'}
                stroke={'#000'}
                strokeWidth={2}
                strokeMiterlimit={10}
                x="3"
                y="5"
                width="34"
                height="30"
            />
        </svg>
    )
}

export default RectangleSVG
